<template>
<div class="carf">
    <div  v-for="(i, index) in Object.values(User.monthlyPerformance)" :key="i">
    <v-card v-if="index + 1 < 7" elevation="6" class="carg">
        <div :class="index%2 == '1'  ? 'Date' : 'Date1'">
            <p :class="index%2 == '1' ? 'tim' : 'tim1'"> {{DisplayTime()}}</p>
        </div> 
        <div v-if="index+1 == 1"  class="other">
            <h5>Bank Transfer</h5>
            <small>{{User.monthlyPerformance.bankTransferVolume}} Transactions</small>
            <div class="amo">Total Amount</div>
            <p class="ream">{{DisplayCurrency(User.monthlyPerformance.bankTransferValue/100)}}</p>
        </div>
         <div v-if="index+1 == 2"  class="other">
            <h5>FRSC Payment</h5>
            <small>{{User.monthlyPerformance.frscVolume}} Transactions</small>
            <div class="amo">Total Amount</div>
            <p class="ream">{{DisplayCurrency(User.monthlyPerformance.frscValue/100)}}</p>
        </div>
         <div v-if="index+1 == 3"  class="other">
           <h5>NIS Payment</h5>
            <small>{{User.monthlyPerformance.nisVolume}} Transactions</small>
            <div class="amo">Total Amount</div>
            <p class="ream">{{DisplayCurrency(User.monthlyPerformance.nisValue/100)}}</p>
        </div>
         <div v-if="index+1 == 4"  class="other">
            <h5>Airtime</h5>
            <small>{{User.monthlyPerformance.airtimeVolume}} Transactions</small>
            <div class="amo">Total Amount</div>
            <p class="ream">.</p>
        </div>
         <div v-if="index+1 == 5"  class="other">
            <h5>Electricity</h5>
            <small>{{User.monthlyPerformance.electricityVolume}} Transactions</small>
            <div class="amo">Total Amount</div>
            <p class="ream ">.</p>
        </div>
         <div v-if="index+1 == 6"  class="other">
            <h5>Tv And Internet</h5>
            <small>{{User.monthlyPerformance.tvAndInternetVolume}} Transactions</small>
            <div class="amo">Total Amount</div>
             <p class="ream">.</p> 
        </div>
    </v-card>
    </div>
</div>
</template>
<script>
import dayjs from "dayjs";
import currencyFormatter from 'currency-formatter'


export default {

    methods: {
    DisplayTime(payload) {
        return dayjs(payload).format('MMMM YYYY')
        },

    DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
    },
    },
    computed: {
       User () {
        return this.$store.getters.getUser
        }
    }
}
</script>
<style scoped>

@font-face {
font-family:'AvenirLTProMedium';
src: url('~@/assets/font/AvenirLTProMedium.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'AvenirLTProBookOblique';
src: url('~@/assets/font/AvenirLTProBookOblique.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'AvenirLTProHeavy';
src: url('~@/assets/font/AvenirLTProHeavy.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'FontsFree-Net-SFProDisplay-Regular';
src: url('~@/assets/font/FontsFree-Net-SFProDisplay-Regular.ttf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'SF-UI-Display-Bold';
src: url('~@/assets/font/SF-UI-Display-Bold.otf');
font-weight: normal;
font-style: normal;
}
@font-face {
font-family:'AvenirLTProBook';
src: url('~@/assets/font/AvenirLTProBook.otf');
font-weight: normal;
font-style: normal;
}

.carg{
    min-height: 130px;
    border-bottom-right-radius: 20px !important;
    margin: 18px;
    min-width: 140px;
    padding-top: 5px;;
    box-shadow: 0 12px 40px 0 rgba(189, 36, 39, 0.1)!important;
    background-color: #ffffff!important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.carf{
 display: flex;
 min-height: 130px;
 overflow-y: scroll;
}

.carf::-webkit-scrollbar {
  display: none;
}

.Date{
width: 113px;
height: 31.1px;
background-color: rgba(179, 1, 245, 0.35);
border-bottom-right-radius: 10px !important;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding-top: 15px;
margin-top: 20px;
}

.Date1{
width: 113px;
height: 31.1px;
background-color: rgba(183, 146, 0, 0.35);
border-bottom-right-radius: 10px !important;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding-top: 15px;
margin-top: 20px;
}
.dot{
  color:white
}

.Date small{
    color: white;
}
.other{
    padding: 10px;
}
.other p{
    font-size: 10px;
    margin-top: 5px;
}
h5{
  font-family: 'AvenirLTProBook';
  font-size: 10px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.2;
  letter-spacing: normal;
  color: #000000;
}
.tim{
  width: 77.6px;
  height: 18px;
  font-family: 'FontsFree-Net-SFProDisplay-Regular';
  font-size: 10px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.2;
  letter-spacing: normal;
  color: #75039f;
}
.tim1{
  width: 77.6px;
  height: 18px;
  font-family: 'FontsFree-Net-SFProDisplay-Regular';
  font-size: 10px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.2;
  letter-spacing: normal;
  color: #b79200;
}

.amo{
  font-family: 'FontsFree-Net-SFProDisplay-Regular';
  font-size: 10px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.14;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.6);
}
.ream{
  font-family: 'FontsFree-Net-SFProDisplay-Regular';
 font-size: 9px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.44;
  letter-spacing: normal;
  color: rgba(126, 126, 126, 0.79)
}

</style>